import React, { Component, useRef } from 'react';
import classes from './UpdateNotification.module.scss';
import globalJson from '../../../data/global.json';
import { getFileName } from '../../../helpers/FileCaching';
import ServiceWorkerNotifications from 'helpers/ServiceWorkerNotifications'

const globalImages = require.context('../../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);

class UpdateNotification extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hasUpdates:false
        }

        this.reg = React.createRef(null)

    }

    componentDidMount(){
        let self = this
        navigator.serviceWorker.getRegistration().then(function(reg){
            self.reg.current = reg
            self.listenForWaitingServiceWorker(reg, self.promptUserToRefresh);

            // reload once when the new Service Worker starts activating
            var refreshing;
            navigator.serviceWorker.addEventListener('controllerchange',
            function() {
                if (refreshing) return;
                refreshing = true;
                self.setState({
                    hasUpdates:true
                })
            });

        })
    }

    listenForWaitingServiceWorker(reg, callback) {
        function awaitStateChange() {
          reg.installing.addEventListener('statechange', function() {
            if (this.state === 'installed') callback(reg);
          });
        }
        if (!reg) return;
        if (reg.waiting) return callback(reg);
        if (reg.installing) awaitStateChange();
        reg.addEventListener('updatefound', awaitStateChange);
    }

    promptUserToRefresh(reg) {
        // this is just an example
        // don't use window.confirm in real life; it's terrible
        console.log("WE HAVE AN UPDATE WAITING! ", this.reg.current)
        this.setState({
            hasUpdates:true
        })
    }

    render() {
        let button = "";

        if(this.state.hasUpdates) {
            button = 
                <div 
                    className={classes['background']}
                    onClick={() => {window.location.reload();}} 
                    >
                    <img className={classes['opt-in-msg']}
                        src={getFileName(globalImages, 'update-bar.svg')}
                    />
                </div>
            {return (
                <div className={classes['notification-opt']}>
                    { button }
                </div>
            )}
        }

        return (
            <div>
            </div>
        )
    }
}

export default UpdateNotification;